module.exports = __webpack_public_path__ + "static/img/img_err.9ef2c6a3.png";